import styled from 'styled-components';
import React from 'react';
import CheckCircleFilledIcon from '../../assets/icons/checkCircleFilled.svg?react';
import CircleFilledIcon from '../../assets/icons/circleFilled.svg?react';
import LoadingIcon from '../../assets/icons/loading.svg?react';

const StyledChecklistItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 18px;
`;

const Content = styled.div`
  flex: 1;
`;

const PENDING_ICON_SIZE = 16;
const ICON_SIZE = 20;

// TODO: Clean up the SVG to not require a viewBox defined around the icon
const CompletedIcon = () => {
  return (
    <CheckCircleFilledIcon
      color="var(--green-400)"
      title="Completed"
      viewBox="0 0 15 15.5"
      width={ICON_SIZE}
      height={ICON_SIZE}
    />
  );
};

const PendingIconContainer = styled.div`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PendingIcon = () => {
  return (
    <PendingIconContainer>
      <CircleFilledIcon
        color="var(--grayscale-200)"
        title="Pending"
        width={PENDING_ICON_SIZE}
        height={PENDING_ICON_SIZE}
      />
    </PendingIconContainer>
  );
};

const InProgressIcon = () => {
  return <LoadingIcon color="var(--green-400)" title="Loading" width={ICON_SIZE} height={ICON_SIZE} />;
};

export type ChecklistItemStatus = 'complete' | 'pending' | 'loading';

export type ChecklistItemProps = {
  /**
   * Class name for additional styling; used to pass down styles when using inheritance in styled components
   */
  className?: string;
  /**
   * Status of the checklist item
   */
  status?: ChecklistItemStatus;
  /**
   * Children of the component - can be text, buttons, or any React nodes
   */
  children: React.ReactNode;
};

const getIconByStatus = (status: ChecklistItemStatus) => {
  switch (status) {
    case 'complete':
      return <CompletedIcon />;
    case 'loading':
      return <InProgressIcon />;
    case 'pending':
    default:
      return <PendingIcon />;
  }
};

/**
 * A checklist item component that displays with different icons based on status.
 * Can contain any content including buttons.
 */
export const ChecklistItem = ({ className, status = 'pending', children }: ChecklistItemProps) => {
  return (
    <StyledChecklistItem className={className}>
      {getIconByStatus(status)}
      <Content>{children}</Content>
    </StyledChecklistItem>
  );
};

export default ChecklistItem;
